module.exports = fox => {
    $.migrateMute = true;

    require('jquery-migrate');
    require('jquery-ui/ui/core');
    require('jquery-ui/ui/widget');
    require('jquery-ui/ui/tooltip');
    
    require('script!highcharts');

    require('widget/copyright')(fox);
    require('widget/captcha')(fox);
    require('widget/grid/list/widgets')(fox);
    require('popupWidget')(fox);
    require('intercom')(fox);

    require('common-stuffs/localStorageService')(fox);
    require('through-notifications')(fox);

    require('script!clipboard/dist/clipboard');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/dependencies/index.es.js